var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1755440560291,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 6669,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M560.86064 480h-105.6v-94.4H560.86064V480z m0-326.4h-105.6v97.6H560.86064V153.6z m124.8 232h-105.6V480h105.6v-94.4z m-249.6-115.2h-105.6v96h105.6v-96z m124.8 0h-105.6v96H560.86064v-96z m443.2 160c-22.4-16-76.8-20.8-116.8-12.8-4.8-38.4-27.2-72-65.6-102.4l-22.4-14.4-14.4 22.4c-28.8 44.8-36.8 118.4-6.4 166.4-14.4 8-41.6 17.6-76.8 17.6H4.06064c-14.4 81.6 9.6 187.2 70.4 259.2 59.2 70.4 148.8 105.6 264 105.6 251.2 0 438.4-115.2 524.8-326.4 33.6 0 108.8 0 145.6-72 1.6-3.2 11.2-20.8 12.8-27.2l-17.6-16z m-817.6-44.8H80.86064V480h105.6v-94.4z m124.8 0h-105.6V480h105.6v-94.4z m124.8 0h-105.6V480h105.6v-94.4z m-124.8-115.2h-105.6v96h105.6v-96z",
    "p-id": 6670
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocker);
export default __webpack_public_path__ + "static/media/docker.ef5b559dd203a1942d7099fcdbb89e9b.svg";
export { ForwardRef as ReactComponent };